<template>
  <div>
    <v-dialog max-width="80%" v-model="dialog">
      <PdfViewer v-if="base64.detectMimeType(data) == 'application/pdf'"
                 :base64="'data:' + base64.detectMimeType(data) +';base64,' + data"></PdfViewer>
      <div v-else>
        <v-card v-if="data">
          <v-card-title>
            <h2>{{ field.name }}</h2>
          </v-card-title>
          <v-card-text>
            <v-divider></v-divider>
            <div>
              <img v-if="data" @click="openImage(data,'image/jpg')" style="max-width: 100%;display:block; margin: auto auto;"
                   :src="'data:image/jpg;base64,'+ data"/>
              <div v-else>Brak</div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn  color="red" @click="dialog=false">Zamknij</v-btn>
            <v-btn  color="green" @click="downloadImg">Pobierz</v-btn>
          </v-card-actions>
        </v-card>

        <v-card v-else>
          <v-card-title>
            {{ $t('related.no_data') }}
          </v-card-title>
        </v-card>
      </div>

      <template v-slot:activator="{ on }">
        <v-btn v-if="base64.detectMimeType(data) == 'application/pdf'" color="red" outline round @click="openImage()">
          PDF
        </v-btn>
        <img v-else :src="'data:' + base64.detectMimeType(data) +';base64,'+ data" class="imageField"
             @click="openImage()"/>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import PdfViewer from "@/components/pdf/Viewer.vue"
import Base64 from "@/helpers/Base64"

export default {
  components: {PdfViewer},
  props: ["data", "field"],
  data() {
    return {
      dialog: false,
      loading: true,
      base64: new Base64()

    }
  },
  computed: {
    locale: () => process.env.VUE_APP_LOCALE
  },
  created() {

  },
  methods: {
    openImage() {
      this.dialog = true
    },
    downloadImg(){
      let link = document.createElement('a');
      link.download = this.field.name + this.getExtension(this.base64.detectMimeType(this.data))
      link.href = 'data:' + this.base64.detectMimeType(this.data) + ';base64,' + this.data
      link.click();
    },
    getExtension(mimeType) {
      switch (mimeType) {
      case 'image/png':
        return ".png"
      case 'image/jpg':
        return ".jpg"
      case 'application/pdf':
        return ".pdf"
      default:
        ""
      }
    }
  },
}
</script>

<style scope>
.imageField {
  height: 100px;
  cursor: pointer;
}
</style>
